import R from 'ramda';
import utils from './utils';

const URL = `${BASE_API_URL}/employees`;

export default {
    getTeachers: () => utils.get(`${URL}/teachers/list.json`),
    getTeacher: id => utils.get(`${URL}/teachers/${id}.json`),
    updateTeacher: (id, data, photo) => utils.put(`${URL}/teachers/${id}.json`, {...data, photo}),
    createTeacher: data => utils.post(`${URL}/teachers/list.json`, data),
    deleteTeacher: id => utils.delete(`${URL}/teachers/${id}.json`),
    getContracts: profileId => utils.get(`${URL}/profiles/${profileId}/contracts.json`),
    getContractPreview: (profileId, data) => utils.post(
        `${URL}/profiles/${profileId}/contracts/preview.json`,
        R.reject(R.isEmpty, data)
    ),
    createContract: (profileId, data) => utils.post(`${URL}/profiles/${profileId}/contracts.json`, data),
    verifyContract: (profileId, contractId, data) => utils.put(
        `${URL}/profiles/${profileId}/contracts/verify/${contractId}.json`, data, 'multipart/form-data',
        ),
    getLastContractUid: () => utils.get(`${URL}/contracts/last.json`).then(R.prop('uid')),
}



// WEBPACK FOOTER //
// ./src/api/employees.js